/* global axios */
import ApiClient from './ApiClient';

class CrmPipelinesAPI extends ApiClient {
  constructor() {
    super('crm/pipelines', { accountScoped: true });
  }

  getStages(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/stages`);
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/stages`, data);
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, data);
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  getCards(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/cards`, { params });
  }

  createCard(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/cards`, data);
  }

  updateCard(pipelineId, cardId, data) {
    return axios.patch(`${this.url}/${pipelineId}/cards/${cardId}`, data);
  }

  deleteCard(pipelineId, cardId) {
    return axios.delete(`${this.url}/${pipelineId}/cards/${cardId}`);
  }

  moveCard(pipelineId, cardId, stageId, position) {
    return axios.patch(`${this.url}/${pipelineId}/cards/${cardId}/move`, {
      stage_id: stageId,
      position,
    });
  }
}

export default new CrmPipelinesAPI();
